import {defineStore} from 'pinia'
import {client} from "@/libraries/http";
import idGenerate from "@/libraries/id-generate";
// import {client} from "@/libraries/http";

// const rebuildEntityTree = (value, arr) => {
//     if (!arr) {
//         return []
//     }
//     let newarr = [];
//     arr.forEach(element => {
//         if (element.name.indexOf(value) > -1) {
//             const ab = rebuildEntityTree(value, element.children);
//             const obj = {
//                 id: idGenerate(),
//                 ...element,
//                 children: ab,
//                 isLeaf: ab.length < 1,
//                 dragDisabled: true,
//                 addTreeNodeDisabled: true,
//                 addLeafNodeDisabled: true,
//                 editNodeDisabled: true,
//                 delNodeDisabled: true,
//             }
//             newarr.push(obj);
//         } else {
//             if (element.children && element.children.length > 0) {
//                 const ab = rebuildEntityTree(value, element.children);
//                 const obj = {
//                     ...element,
//                     children: ab,
//                     isLeaf: ab.length < 1,
//                     dragDisabled: true,
//                     addTreeNodeDisabled: true,
//                     addLeafNodeDisabled: true,
//                     editNodeDisabled: true,
//                     delNodeDisabled: true,
//                 };
//                 newarr.push(obj);
//             }
//         }
//     });
//     return newarr;
// };

const searchNodes = (nodes, value, level) => {
    if (!level) {
        level = 0
    }
    if (!nodes || nodes.length <= 0) {
        return []
    }
    return nodes.filter(node => node.name.toUpperCase().includes(value.toUpperCase()) || searchNodes(node.children, value, level + 1).length > 0)
        .map(node => {
            const children = searchNodes(node.children, value, level + 1)
            return {
                id: idGenerate(),
                name: node.name,
                level,
                children: children,
                isLeaf: children.length < 1,
                dragDisabled: true,
                addTreeNodeDisabled: true,
                addLeafNodeDisabled: true,
                editNodeDisabled: true,
                delNodeDisabled: true,
            }
        })
};

// const searchTree = (node, value) => {
//     if (!node) {
//         return null
//     }
//
//     // 不存在该字符串且不存在子节点，直接返回
//     if (!node.name.includes(value)
//         && (!node.children || node.children.length <= 0)) {
//         return null
//     }
//
//     let children = []
//     if (node.children) {
//         children = node.children
//             .map(child => searchTree(child, value))
//             .filter(child => child)
//     }
//
//     if (!node.name.includes(value) || children.length <= 0) {
//         return null;
//     }
//
//     return {
//         id: idGenerate(),
//         name: node.name,
//         children,
//         isLeaf: children.length <= 0,
//         dragDisabled: true,
//         addTreeNodeDisabled: true,
//         addLeafNodeDisabled: true,
//         editNodeDisabled: true,
//         delNodeDisabled: true,
//     }
// }

const useConstructionLocationPickerStore = defineStore('construction-location-picker', {
    state: () => ({
        picked: null,
        items: [],
        projectId: null,
        locations: [],
        locationResult: null,
    }),
    // getters: {
    //     getForm(state) {
    //         return state.form;
    //     },
    // },
    actions: {
        init(cheetahId) {
            if (this.projectId !== cheetahId || !this.locationResult) {
                this.projectId = cheetahId
                return client.get(`/api/h5/leo-projects/${cheetahId}/location-tree`)
                    .then((res) => {
                        this.locationResult = res.data.children?.find(area => area.name === '租户区域');
                    });
            } else {
                return Promise.resolve(this.locationResult);
            }
        },
        initAndSearch(cheetahId, searchValue) {
            return this.init(cheetahId).then(() => this.search(searchValue))
        },
        search(searchValue) {
            this.locations = searchNodes(this.locationResult.children, searchValue)
            console.log(this.locations)
            return this.locations
        },
        setProjectId(projectId) {
            this.projectId = projectId;
        },
        pick(item) {
            this.picked = item;
        },
        load() {
            // if (cheetahId) {
            //    return client.get(`/api/leo-projects/${cheetahId}/profit-centers`)
            //         .then(res => {
            //             this.items = res.data;
            //             this.pickIfNull(this.items[0]);
            //         });
            // } else {
            //     return client.get('/api/profit-centers')
            //         .then(res => {
            //             this.items = res.data;
            //             this.pickIfNull(this.items[0]);
            //         });
            // }
        },
        reset() {
            this.picked = null;
        }
    },
})

export default useConstructionLocationPickerStore;
